module.exports = __webpack_public_path__ + "media/images/wwk_logo-e990efaa167106d6a2d5b47146a783a9.jpg";